import {Component, OnInit, Input} from '@angular/core'
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument
} from '@angular/fire/firestore'
import {AuthService} from '../auth.service'
import {GenpdfService} from '../dashboard/genpdf.service'
import {Observable, of} from 'rxjs'
import {NbSidebarService} from '@nebular/theme'
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dashboards',
  templateUrl: './dashboards.component.html',
  styleUrls: ['./dashboards.component.scss']
})
export class DashboardsComponent implements OnInit {
  @Input() dashboardType: string
  dashboards: Observable<any[]>
  itemsCollection: AngularFirestoreCollection<any>
  dashboardId: string
  showDashboard: boolean = false
  userid: string
  editId = ''
  userpro = false;
  dataModal: any;

  constructor(
    public auth: AuthService,
    private afs: AngularFirestore,
    private sidebarService: NbSidebarService,
    private modalService: NgbModal,
    private genPdf: GenpdfService
  ) {
    if (this.dashboardType) {
    } else {
      this.dashboardType = 'tradedata'
    }
    try {
      auth.user$.subscribe(
        user => {
          this.userid = user.uid
          if (user.userType==="pro") {
            this.userpro = true;
          }
          this.itemsCollection = afs.collection<any>('users/' + user.uid + '/dashboards', ref => {
            //     // Compose a query using multiple .where() methods
            return ref.where('tipo', '==', this.dashboardType).orderBy('order')
          })
          this.dashboards = this.itemsCollection.valueChanges()
          this.dashboards.subscribe(
            dash => {
              //Se crea el dashboard inicial
              if (dash.length === 0) {
                this.createDashBoard(0)
              } else {
                this.dashboardId = dash[0].id
              }

              this.showDashboard = true
            },

            error => {
              console.log(error, 'error')
            }
          )
        },
        error => {
          console.log(error, 'error')
        }
      )
    } catch (e) {
      console.log(e)
    }
  }

  ngOnInit() {}

  setDashboardid(id) {
    this.sidebarService.collapse('right')
    this.showDashboard = false
    this.dashboardId = id
    this.showDashboard = true
  }
  mostrarDash() {
    this.showDashboard = true
  }
  createDashBoard(index) {
    this.showDashboard = false
    const id = this.afs.createId()
    const chartRef: AngularFirestoreDocument<any> = this.afs.doc(
      'users/' + this.userid + '/dashboards/' + id
    )
    const data = {
      id: id,
      titulo: 'dashboard',
      order: index,
      tipo: this.dashboardType
    }

    chartRef.set(data, {merge: true})
    this.dashboardId = id
    this.showDashboard = true
  }

  saveName(dashboard) {
    const chartRef: AngularFirestoreDocument<any> = this.afs.doc(
      'users/' + this.userid + '/dashboards/' + this.editId
    )

    chartRef.set(dashboard, {merge: true})

    this.editId = ''
  }

  removeDashboard(id) {
    const chartRef: AngularFirestoreDocument<any> = this.afs.doc(
      'users/' + this.userid + '/dashboards/' + id
    )
    chartRef.delete()
    this.editId = ''
    this.modalService.dismissAll('deeted');
  }
  deleteDashboard(content, item) {
    this.dataModal= item;
    this.modalService.open(content);
  }
  downloadPDF() {
    const data:any ='hola';
    this.genPdf.descargarPdf(data);
  }
}
